.confirmationModal {
  z-index: 5000;

  > .content {
    text-align: center;

    @media (min-width: 769px) {
      max-width: 25rem;
      margin: 10% auto;
    }
  }

  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 0 1rem;
    text-align: center;

    @media (min-width: 400px) {
      margin: 0 0 1.5rem;
    }

    @media (min-width: 769px) {
      margin: 0 0 1.625rem;
    }

    @media (min-width: 1025px) {
      margin: 0 0 1.875rem;
    }
  }
}
